export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11669.0f74cbbd.jpg";